import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { BlockChooser, Icon } from '@plone/volto/components';
import { usePopper } from 'react-popper';
import { createPortal } from 'react-dom';
/* START CUSTOMIZATION */
import addSVG from '@plone/volto/icons/circle-plus.svg';
/* END CUSTOMIZATION */

const messages = defineMessages({
  AddBlockInPosition: {
    id: 'add_block_in_position',
    defaultMessage: 'Add block in position',
  },
});

const OpenedBlocksChooser = (props) => {
  const { blocksConfig, block, onInsertBlock } = props;

  const ref = React.useRef(null);

  function handleClickOutside(event) {
    if (ref.current && !ref.current.contains(event.target)) {
      props.setOpenMenu(false);
    }
  }

  React.useEffect(() => {
    document.body.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.body.removeEventListener('mousedown', handleClickOutside);
    };
  });

  return (
    <BlockChooser
      onInsertBlock={onInsertBlock}
      currentBlock={block}
      blocksConfig={blocksConfig}
      ref={ref}
    />
  );
};

const NewBlockAddButton = (props) => {
  const { index, intl } = props;
  const [isOpenMenu, setOpenMenu] = React.useState(false);

  const referenceElement = React.useRef(null);
  const popperElement = React.useRef(null);
  const { styles, attributes } = usePopper(
    referenceElement.current,
    popperElement.current,
    {
      /* START CUSTOMIZATION */
      placement: 'bottom',
      /* END CUSTOMIZATION */
      modifiers: [
        {
          name: 'offset',
          options: {
            /* START CUSTOMIZATION */
            offset: [0, 5],
            /* END CUSTOMIZATION */
          },
        },
        {
          name: 'flip',
        },
      ],
    },
  );

  return (
    <>
      <button
        onClick={() => setOpenMenu(true)}
        /* START CUSTOMIZATION */
        className="add-block-button ui basic icon button block-add-button new-add-block"
        /* END CUSTOMIZATION */
        aria-label={`${intl.formatMessage(
          messages.AddBlockInPosition,
        )} ${index}`}
        ref={referenceElement}
      >
        {/* START CUSTOMIZATION */}
        <Icon name={addSVG} size="24px" />
        {/* END CUSTOMIZATION */}
      </button>
      {createPortal(
        <div
          ref={popperElement}
          style={styles.popper}
          {...attributes.popper}
          className="accordion-chooser"
        >
          {isOpenMenu ? (
            <OpenedBlocksChooser {...props} setOpenMenu={setOpenMenu} />
          ) : null}
        </div>,
        document.body,
      )}
    </>
  );
};

export default injectIntl(NewBlockAddButton);
